import { UnifiedRoutingActionDetail } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingActionDetail';
import { ROUTING_ROTATE_TICKET_OWNER } from 'automation-ui-action-features/constants/Gates';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { TICKET_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RotateObjectActionSummary({
  actionMetadata,
  flowObjectTypeId
}) {
  const isUngatedToSVHTicketRouting = useIsUngated(ROUTING_ROTATE_TICKET_OWNER);
  if (!flowObjectTypeId) {
    return null;
  }
  if (flowObjectTypeId === TICKET_ID && isUngatedToSVHTicketRouting) {
    return /*#__PURE__*/_jsx(UnifiedRoutingActionDetail, {
      actionMetadata: actionMetadata,
      objectTypeId: flowObjectTypeId
    });
  }
  const teamIds = actionMetadata.teamIds || [];
  const userIds = actionMetadata.userIds || [];
  return teamIds.length > 0 ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.rotate-object.summary.between-teams_cob",
    objectTypeId: flowObjectTypeId,
    options: {
      count: teamIds.length
    }
  }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.rotate-object.summary.between-users_cob",
    objectTypeId: flowObjectTypeId,
    options: {
      count: userIds.length
    }
  });
}